import {
  faHeartPulse,
  faUtensils,
  faUserDoctor,
} from '@fortawesome/free-solid-svg-icons'

export const mockTasks = [
  {
    id: 1,
    category: 'morning',
    tasks: [
      {
        id: 'bp1',
        title: 'Morning Blood Pressure',
        time: '08:00 AM',
        status: 'pending',
        points: 20,
        icon: faHeartPulse,
        context: 'Important: Your evening readings suggest closer morning monitoring',
        inputType: 'bp',
        priority: 'high'
      },
      {
        id: 'breakfast',
        title: 'Log Breakfast',
        time: '08:30 AM',
        status: 'completed',
        points: 15,
        icon: faUtensils,
        context: 'Recommendation: High protein breakfast from FIRE Cookbook (Page 12-15)',
        inputType: 'meal',
        priority: 'medium'
      },
      {
        id: 'doctor',
        title: 'Doctor Appointment',
        time: '10:30 AM',
        status: 'pending',
        points: 30,
        icon: faUserDoctor,
        context: 'Annual check-up with Dr. Smith - Bring your BP readings log',
        inputType: 'appointment',
        priority: 'high',
        location: 'Health Center, Room 205'
      }
    ]
  },
  // ... rest of the mock data
] 